import $common from '../common'
import moment from 'moment'
export default {
	namespaced: true,
	state: {
		consultOrder: {
			isDeduct: 1,
			consultContent: '',
			consultFilePathList: []
		}
	},
	getters: {
		getOrderDetail: state => $common.storeGetterSessionCommon(state, 'consultOrder', 'object')
	},
	mutations: {
		['SET_ORDER_DETAIL'](state, val) {
			state.consultOrder = { ...state.consultOrder, ...val }
			window.sessionStorage.setItem('consultOrder', JSON.stringify(val))
		}
	},
	actions: {
		/**
		 * @method 缓存订单
		 * @params { cb } 回调方法
		 */
		async consultOrder({ commit }, { params }) {
			let item = params
			moment.locale('zh-cn', {
				weekdays: '周日_周一_周二_周三_周四_周五_周六'.split('_')
			})
			item['subscribeTime'] = `${moment(item.startTime).format('YYYY年MM月DD日（dddd） HH:mm-')}${moment(
				item.endTime
			).format('HH:mm')}`
			commit('SET_ORDER_DETAIL', item)
		}
	}
}
